import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "../buttons/button";
import { CancelSvg } from "../../../svgFiles/CancelSvg";
import "./commonModal.css";
import useTranslator from "../../../hooks/useTranslator";
const CommonModal = ({
  children,
  show,
  className,
  title,
  headerInfo,
  handleClose,
  headername,
  BatchCode,
  PalletCode,
  BatchCodeInfo = true,
  size = "lg",  //'sm' | 'lg' | 'xl'
}) => {
  const { _t } = useTranslator();
  return (
    <Modal
      show={show}
      onHide={handleClose}
      className={`${className} modal_wrapper`}
      centered
      size={size}
    >
      <Modal.Header>
        {headerInfo ? (
          <div className="flex-grow-1 text-center overviewHead">
            <h6>{_t("data_overview", "Data Overview")}</h6>
            <h4>
              {" "}
              {headername}{" "}
              {BatchCodeInfo ? (
                <span>{`(${_t("batch_code", "Batch Code")}: ${BatchCode} )`}</span>
              ) : (
                <span>{PalletCode}</span>
              )}
            </h4>
          </div>
        ) : (
          <Modal.Title>{_t(title, title)}</Modal.Title>
        )}
        <Button onClick={handleClose} icon={CancelSvg} size="small"></Button>
      </Modal.Header>
      <Modal.Body className="p-4">{children}</Modal.Body>
    </Modal>
  );
};

export default CommonModal;
